<template>
  <div id="app2">
    <!-- END MENU SIDEBAR WRAPPER -->
    <!-- {{ mytopicList }} -->
    <div class="main-content">
      <div class="content page-aside-left">
        <div class="main-content">
          <course-header></course-header>
          <section class="page-content container-fluid">
            <div class="row">
              <div class="col-4 col-md">
                <div class="card bg-primary" style="height: 150px">
                  <div
                    class="
                      card-body
                      d-flex
                      align-content-between
                      flex-wrap
                      mfilter-board
                    "
                    @click="
                      courseOverview.book === 0 ? '' : changeMfilter('openb')
                    "
                    data-toggle="tooltip"
                    data-placement="bottom"
                    :title="$t('click-to-switch-filter')"
                  >
                    <h5 class="card-title">
                      <!-- {{ $t("books") }} -->
                      {{ $t("books-open-up") }}
                      <i
                        class="far fa-lightbulb fa-lg mfilter-icon fa-lg"
                        :class="mfilter === 'openb' ? 'text-warning' : ''"
                      ></i>

                      <!-- Picture Book Views<span class="text-light">Teacher</span> -->
                    </h5>
                    <div class="w100 text-right">
                      <p class="card-text text-white">
                        <span
                          class="display-5 counter"
                          data-count="13"
                          v-if="courseOverview.allbook !== 0"
                          >{{ courseOverview.book }}/{{
                            courseOverview.allbook
                          }}</span
                        >
                        <span v-else class="display-5 counter" data-count="13"
                          >N/A</span
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-4 col-md">
                <div class="card bg-secondary" style="height: 150px">
                  <div
                    class="
                      card-body
                      d-flex
                      align-content-between
                      flex-wrap
                      mfilter-board
                    "
                    @click="
                      courseOverview.video === 0 ? '' : changeMfilter('openv')
                    "
                    data-toggle="tooltip"
                    data-placement="bottom"
                    :title="$t('click-to-switch-filter')"
                  >
                    <h5 class="card-title">
                      <!-- {{ $t("videos") }} -->
                      {{ $t("videos-open-up") }}
                      <i
                        class="far fa-lightbulb fa-lg mfilter-icon fa-lg"
                        :class="mfilter === 'openv' ? 'text-warning' : ''"
                      ></i>
                      <!-- Video Views<span class="text-light">Teacher</span> -->
                    </h5>
                    <div class="w100 text-right">
                      <p class="card-text text-white">
                        <span
                          class="display-5 counter"
                          data-count="29"
                          v-if="courseOverview.allvideo !== 0"
                          >{{ courseOverview.video }}/{{
                            courseOverview.allvideo
                          }}</span
                        >
                        <span v-else class="display-5 counter" data-count="29"
                          >N/A</span
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6 col-md">
                <div class="card bg-warning" style="height: 150px">
                  <div class="card-body d-flex align-content-between flex-wrap">
                    <h5 class="card-title text-white">
                      {{ $t("number-of-books-viewed") }}
                      <!-- <span class="text-light">{{ $t("student") }}</span> -->
                    </h5>
                    <div class="w100 text-right">
                      <p class="card-text text-white">
                        <span
                          class="display-5 counter"
                          data-count="173"
                          v-if="courseOverview.allbook !== 0"
                          >{{ courseOverview.readBook }}</span
                        >
                        <span v-else class="display-5 counter">N/A</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6 col-md">
                <div class="card bg-danger" style="height: 150px">
                  <div class="card-body d-flex align-content-between flex-wrap">
                    <h5 class="card-title text-white">
                      {{ $t("number-of-videos-viewed") }}
                      <!-- <span class="text-light">{{ $t("student") }}</span> -->
                    </h5>
                    <div class="w100 text-right">
                      <p class="card-text text-white">
                        <span
                          class="display-5 counter"
                          data-count="197"
                          v-if="courseOverview.allvideo !== 0"
                          >{{ courseOverview.watchVideo }}</span
                        >
                        <span v-else class="display-5 counter">N/A</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- color card end -->
            <FilterButtonGroup
              :mfilter="mfilter"
              :selectLevelList="selectLevelList"
              :searchKeyword="searchKeyword"
              @getMList="getMList"
              @getFilterInfo="getFilterInfo"
              @getTopicList="getTopicList"
              @addselectLevelList="addselectLevelList"
              ref="fbg"
            ></FilterButtonGroup>
            <!-- <div class="btn-group mb-4" role="group" aria-label="Basic example">
              <button type="button" class="btn btn-secondary">Left</button>
              <button type="button" class="btn btn-secondary">Middle</button>
              <button type="button" class="btn btn-secondary">Right</button>
            </div> -->
            <!--  -->
            <div class="d-flex justify-content-between">
              <div class="col-sm-12 row">
                <div
                  class="text-left col-sm-12 px-0 mb-2"
                  v-if="$route.params.expired !== 'expired'"
                >
                  <button
                    type="button"
                    class="btn btn-primary btn-rounded btn-outline mr-1"
                    data-toggle="modal"
                    data-target="#OpenSettingsModal"
                    @click="copyMArray()"
                  >
                    <i class="la la-gear"></i>{{ $t("quick-open-up") }}
                  </button>

                  <button
                    type="button"
                    class="btn btn-primary btn-rounded btn-outline mr-1"
                    @click="openAssignmentModal()"
                    :disabled="tempAList.length === 0 ? true : false"
                  >
                    <i class="la la-clipboard"></i>
                    {{ $t("assignments") }}
                    <span class="badge badge-primary">{{
                      tempAList.length
                    }}</span>
                  </button>

                  <button
                    @click="openTopicModal()"
                    type="button"
                    class="btn btn-primary btn-rounded btn-outline"
                  >
                    <i class="zmdi zmdi-filter-list mr-1"></i>
                    <span v-if="selectTopic === ''">{{
                      $t("video-topic")
                    }}</span>
                    <span v-else> {{ $t("topic") }}: {{ selectTopic }}</span>
                  </button>
                </div>
                <!-- @updateTopic="updateTopic" -->
                <search-group
                  class="col-sm-12 px-0"
                  :mfilter="mfilter"
                  :courseSelectLevelList="selectLevelList"
                  :courseTextbookList="textbookList"
                  :selectTopic="selectTopic"
                  :selectType="selectType"
                  :sortMyList="sortMyList"
                  @getMList="getMList"
                  @getFilterInfo="getFilterInfo"
                  @updateSelectType="updateSelectType"
                  @updateKeyword="updateKeyword"
                ></search-group>
              </div>
            </div>
            <!-- course material List START -->
            <div class="row" v-if="softStatus">
              <div
                class="col-12"
                v-for="textbook in sortMyList"
                :key="textbook.resourceid"
              >
                <div class="card">
                  <div class="card-body">
                    <div class="media">
                      <div
                        class="
                          align-self-center
                          overlay-wrap
                          mr-4
                          w-150
                          h-150
                          border
                        "
                      >
                        <span class="overlay-icon">
                          <i
                            class="fas fa-video"
                            v-if="textbook.note === 'video'"
                          ></i
                          ><i class="fas fa-book-open" v-else></i>
                        </span>
                        <div>
                          <img
                            v-lazy="
                              'https://lms.mangosteems.com/cms/resdl/cover/' +
                                textbook.resourceid
                            "
                            class="overlay-img cus-img"
                            alt="course image"
                          />
                        </div>
                        <!-- v-lazy-container="{
                          loading: '../assets/img/images/Spinner-1s-200px.svg',
                        }" -->

                        <!-- <div
                      title=""
                      class="overlay-img"
                      style="background-image: url(../assets/img/avatars/3.jpg)"
                    ></div> -->
                      </div>
                      <div class="media-body">
                        <div
                          class="col-sm-12 px-0 d-flex justify-content-between"
                        >
                          <div class="px-0 col-sm-12 my-3">
                            <div class="row justify-content-between px-3">
                              <div>
                                <span
                                  class="badge badge-pill badge-secondary mr-1"
                                  v-if="textbook.level !== ''"
                                  >{{ $t("level") }} {{ textbook.level }}</span
                                >
                                <span
                                  class="badge badge-pill badge-secondary "
                                  v-if="textbook.unit !== ''"
                                  >{{ $t("unit") }} {{ textbook.unit }}</span
                                >
                              </div>
                              <!-- START COURSE -->
                              <div
                                class=" justify-content-end  text-primary"
                                v-if="$route.params.expired !== 'expired'"
                              >
                                <h4
                                  @click="gotoWebsite(textbook)"
                                  class="text-primary pointer"
                                >
                                  {{ $t("start")
                                  }}<a
                                    class="
                                btn-rounded-icon btn-primary
                                rounded
                                ml-2
                                pointer
                              "
                                    ><i
                                      class="
                                  zmdi zmdi-arrow-right zmdi-hc-fw
                                  text-white
                                "
                                    ></i>
                                  </a>
                                </h4>
                              </div>
                              <!-- END　START COURSE -->
                            </div>

                            <h4
                              class="
                                mb-0
                                mt-1
                                d-flex
                                align-self-center
                                text-primary
                              "
                            >
                              <div class="text-primary pointer">
                                <span
                                  style="fontSize:28px"
                                  @click="gotoWebsite(textbook)"
                                  class="text-primary pointer mr-1"
                                  >{{ textbook.resource_name }}</span
                                >
                              </div>
                            </h4>
                            <div
                              class="text-secondary   px-0 col-sm-12
                            border-bottom   border-dark"
                              v-if="textbook.supply && textbook.supply.topic"
                            >
                              {{ $t("topic") }}: {{ textbook.supply.topic }}
                            </div>

                            <div class="col-sm-12 row">
                              <div
                                class="text-secondary   px-0 col-sm-12"
                                v-if="textbook.download_link"
                              >
                                {{ $t("download") }}
                              </div>
                              <div
                                v-for="file in textbook.download_link"
                                class=" pointer mr-4  pl-0 mydownload"
                              >
                                <div
                                  target="_blank"
                                  @click="downloadFile(file.link)"
                                  class="download-newblock
                                  d-flex flex-column justify-content-center align-items-center"
                                >
                                  <i
                                    class="
                                      fas
                                      fa-file-download
                                      pointer
                                      fa-2x
                                      download-icon
                                    "
                                  ></i>

                                  <div
                                    style="word-break: break-all;"
                                    class="fw300 text-xs d-flex justify-content-center"
                                  >
                                    <span
                                      class="download-text"
                                      v-if="file.name === 'Worksheet'"
                                    >
                                      {{ $t("worksheet") }}</span
                                    >
                                    <span
                                      class="download-text"
                                      v-else-if="
                                        file.name === 'Worksheet_teacher'
                                      "
                                    >
                                      {{ $t("worksheet_teacher") }}</span
                                    >
                                    <span
                                      class="download-text"
                                      v-else-if="file.name === 'Flashcard'"
                                    >
                                      {{ $t("flashcard") }}</span
                                    >
                                    <span class="download-text" v-else>{{
                                      file.name
                                    }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <p class="text-muted mt-1 mb-0">
                              <span class="fw300 text-xs"
                                >{{ $t("last-played") }}
                                <span v-if="textbook.last_access !== '0'">{{
                                  textbook.last_access | dateConversion
                                }}</span>
                                <span v-else>--</span>
                              </span>
                            </p>
                          </div>
                        </div>
                        <div
                          class="border-top pt-3 d-flex justify-content-between"
                          v-if="$route.params.expired !== 'expired'"
                        >
                          <div>
                            <button
                              v-if="textbook.note === 'video'"
                              type="button"
                              class="
                                btn btn-sm btn-secondary btn-rounded btn-outline
                                mr-2
                              "
                              data-toggle="modal"
                              data-target="#addAssignment"
                              @click="
                                getVideoMaterial(
                                  textbook.colid,
                                  textbook.resourceid
                                );
                                tempRname = textbook.resource_name;
                                tempVMList = tempAIDList;
                              "
                            >
                              <i class="zmdi zmdi-plus zmdi-hc-fw"></i>
                              {{ $t("assignments") }}
                            </button>
                            <button
                              :disabled="
                                tempAIDList.includes(textbook.resourceid)
                              "
                              v-else
                              type="button"
                              class="
                                btn btn-sm btn-secondary btn-rounded btn-outline
                                mr-2
                              "
                              data-toggle="modal"
                              @click="addToAssignmentList(textbook)"
                            >
                              <i
                                class="zmdi zmdi-plus zmdi-hc-fw"
                                v-if="
                                  !tempAIDList.includes(textbook.resourceid)
                                "
                              ></i>
                              <i class="zmdi zmdi-assignment-check" v-else></i>
                              {{ $t("assignments") }}
                            </button>
                            <button
                              type="button"
                              class="
                                btn btn-sm btn-secondary btn-rounded btn-outline
                                mr-2
                              "
                              data-toggle="modal"
                              data-target="#addSpeakingquiz"
                              v-if="textbook.note === 'video'"
                              @click="
                                getVideoMaterial(
                                  textbook.colid,
                                  textbook.resourceid
                                );
                                tempRname = textbook.resource_name;
                              "
                            >
                              <i class="zmdi zmdi-plus zmdi-hc-fw"></i
                              >{{ $t("speaking-task") }}
                            </button>
                            <button
                              type="button"
                              class="
                                btn btn-sm btn-secondary btn-rounded btn-outline
                                mr-2
                              "
                              v-else
                              @click="
                                gotoSpeakingQuiz(
                                  textbook,
                                  textbook.resource_name
                                )
                              "
                            >
                              <i class="zmdi zmdi-plus zmdi-hc-fw"></i
                              >{{ $t("speaking-task") }}
                            </button>
                            <button
                              type="button"
                              class="
                                btn btn-sm btn-secondary btn-rounded btn-outline
                              "
                              data-toggle="modal"
                              @click="
                                getCollectionList(textbook.resourceid, textbook)
                              "
                            >
                              <i class="zmdi zmdi-plus zmdi-hc-fw"></i
                              >{{ $t("my-library") }}
                            </button>
                          </div>
                          <div>
                            <div
                              v-if="textbook.openflag !== 'true'"
                              class="
                                badge badge-dark badge-pill
                                fw300
                                mr-2
                                font-size-md
                              "
                            >
                              {{ $t("closed") }}
                            </div>
                            <div
                              v-if="
                                textbook.openflag === 'true' &&
                                  textbook.note === 'video'
                              "
                              class="
                                badge badge-success badge-pill
                                fw300
                                mr-2
                                font-size-md
                              "
                            >
                              {{ $t("opened") }}
                              <i class="fas fa-video"></i>
                            </div>
                            <div
                              v-else-if="
                                textbook.openflag === 'true' &&
                                  textbook.note === 'book'
                              "
                              class="
                                badge badge-success badge-pill
                                fw300
                                mr-2
                                font-size-md
                              "
                            >
                              {{ $t("opened") }}
                              <i class="fas fa-book-open"></i>
                            </div>
                            <button
                              v-if="textbook.openflag !== 'true'"
                              type="button"
                              class="
                                btn btn-sm btn-secondary btn-rounded btn-outline
                              "
                              data-toggle="modal"
                              data-target="#OpenMaterial"
                              @click="tempResource = textbook"
                            >
                              {{ $t("open-material") }}
                            </button>
                            <button
                              v-else
                              type="button"
                              class="
                                btn btn-sm btn-secondary btn-rounded btn-outline
                              "
                              data-toggle="modal"
                              data-target="#OpenMaterial"
                              @click="tempResource = textbook"
                            >
                              {{ $t("close-material") }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--  -->
            <div v-if="textbookList && textbookList.length === 0">
              <span class="h3" style="'color':#839BB3">
                <i class="la la-info-circle"></i>{{ $t("no-materials") }}
              </span>
            </div>
            <!--  -->
            <!-- course material List END -->
          </section>
        </div>
      </div>
    </div>

    <!-- END CONTENT WRAPPER -->
    <!-- Open material MODAL -->
    <div
      class="modal fade"
      id="OpenMaterial"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-modal="scroll"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" v-if="tempResource.openflag !== 'true'">
              {{ $t("open-material") }}
            </h5>
            <h5 class="modal-title" v-else>{{ $t("close-material") }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true" class="zmdi zmdi-Cancel"></span>
            </button>
          </div>
          <div class="modal-body">
            <p v-if="tempResource.openflag !== 'true'">
              {{ $t("open-material-and-allow-students-to-view-it") }}.
            </p>
            <p v-else>
              {{ $t("close-material-does-not-allow-students-to-view-it") }}.
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-outline btn-rounded"
              data-dismiss="modal"
            >
              {{ $t("cancel") }}
            </button>
            <button
              v-if="tempResource.openflag === 'true'"
              type="button"
              class="btn btn-primary btn-rounded"
              data-dismiss="modal"
              @click="
                getOpenResource(
                  tempResource.colid.split(';')[0],
                  tempResource.resourceid,
                  'false',
                  true
                )
              "
            >
              {{ $t("close") }}
            </button>
            <button
              v-else
              type="button"
              class="btn btn-primary btn-rounded"
              data-dismiss="modal"
              @click="
                getOpenResource(
                  tempResource.colid.split(';')[0],
                  tempResource.resourceid,
                  'true',
                  true
                )
              "
            >
              {{ $t("open") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- addtoColletion MODAL -->
    <div
      class="modal fade"
      id="addtoColletion"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-modal="scroll"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="la la-plus"></i>{{ $t("my-library") }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true" class="zmdi zmdi-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div>
              <!-- 有已存在於collection -->
              <div
                class="form-group row"
                v-if="existCollectionName.length !== 0"
              >
                <label class="control-label text-right col-sm-3">
                  {{ $t("saved") }}
                </label>
                <span class="col-sm-9">
                  <span
                    class="badge badge-secondary badge-pill mr-1"
                    v-for="Cname in existCollectionName"
                    :key="Cname"
                    >{{ Cname }}</span
                  ></span
                >
              </div>
              <!-- 選擇要存在哪個collection -->

              <div
                class="form-group row"
                v-if="filterCollectionList.length !== 0"
              >
                <label class="control-label text-right col-sm-3">
                  {{ $t("add-in") }}
                </label>
                <div class="col-sm-9">
                  <select2
                    id="s2_demo1"
                    :options="filterCollectionList"
                    v-model="selectCol"
                    @select="tempcolid = $event.id"
                  >
                  </select2>
                </div>
              </div>
              <div class="form-group row">
                <label class="control-label text-right col-sm-3">{{
                  $t("sequence")
                }}</label>
                <div class="col-sm-9">
                  <div class="" style="max-height: 300px" data-scroll="dark">
                    <!-- <ul class="sequence border"> -->
                    <li class="d-flex justify-content-between">
                      <div class="btn btn-nostyle btn-move mr-3">
                        {{ tempResource.resource_name }}
                      </div>
                    </li>
                    <!-- </ul> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary btn-outline btn-rounded"
              data-dismiss="modal"
              @click="gotoCreateCol()"
            >
              {{ $t("create-new-library") }}
            </button>

            <button
              v-if="filterCollectionList.length !== 0"
              type="button"
              class="btn btn-primary btn-rounded"
              data-dismiss="modal"
              @click="addResource()"
              :disabled="selectCol === ''"
            >
              {{ $t("add") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- addAssignment modal-->
    <div
      class="modal fade"
      id="addAssignment"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-modal="scroll"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalTitle1">
              <i class="zmdi zmdi-plus zmdi-hc-fw"></i>{{ $t("assignment") }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true" class="zmdi zmdi-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <p>{{ tempRname }}</p>
            <div
              class="custom-control custom-checkbox form-check pb-2"
              v-for="vm in videoMaterialList"
              :key="vm.materialid"
            >
              <input
                type="checkbox"
                class="custom-control-input"
                :value="
                  vm.materialid.toString() + '_' + vm.resourceid.toString()
                "
                :id="vm.materialid.toString() + '_' + vm.resourceid.toString()"
                v-model="tempVMList"
              />
              <label
                class="custom-control-label"
                :for="vm.materialid.toString() + '_' + vm.resourceid.toString()"
                >{{ vm.material_name }}</label
              >
              <!-- <span>{{ vm.materialid }}</span> -->
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-outline btn-rounded"
              data-dismiss="modal"
            >
              {{ $t("close") }}
            </button>
            <button
              type="button"
              class="btn btn-primary btn-rounded"
              @click="addtoSequence()"
              data-dismiss="modal"
            >
              {{ $t("save-changes") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- addSpeakingquiz MODAL -->
    <div
      class="modal fade"
      id="addSpeakingquiz"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-modal="scroll"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalTitle1">
              {{ $t("speaking-quiz") }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true" class="zmdi zmdi-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <p>{{ tempRname }}</p>
            <div>
              <a
                v-for="m in videoMaterialList"
                :key="m.materialid"
                class="btn btn-primary btn-outline btn-block"
                @click="gotoSpeakingQuiz(m, tempRname)"
                >{{ m.material_name }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- openSetting Modal -->
    <div
      class="modal fade"
      id="OpenSettingsModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalTitle1">
              {{ $t("open-settings") }}
            </h5>

            <!-- 12345 -->
            <div class="form-group  ml-auto row">
              <span
                class="h5"
                :class="
                  openAllMaterial === true ? 'text-success' : 'text-black'
                "
                >{{ $t("open-all-materials") }}</span
              >
              <div class="switch pl-2">
                <!-- {{ openAllMaterial }} -->
                <input
                  class="tgl tgl-light tgl-success"
                  id="cb8"
                  type="checkbox"
                  checked
                  v-model="openAllMaterial"
                />
                <label class="tgl-btn" for="cb8"></label>
              </div>
            </div>
            <!--  -->
            <button
              type="button"
              class="close ml-4"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true" class="zmdi zmdi-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div>
              {{ $t("total-of") }}
              <span class="text-primary bold">{{
                courseOverview.allbook + courseOverview.allvideo
              }}</span>
              <!-- <span v-if="textbookList" class="text-primary bold">{{
                textbookList.length
              }}</span> -->
              {{ $t("materials") }}
            </div>
            <div>
              <span class="mr-4" v-if="openedMList"
                >{{ $t("opened") }}：
                <span class="text-success bold">
                  {{ courseOverview.book + courseOverview.video }}
                  <!-- {{
                  openedMList.length
                }} -->
                </span>
              </span>
              <span class="" v-if="closedMList"
                >{{ $t("closed") }}：<span class="bold">{{
                  closedMList.length
                }}</span></span
              >
            </div>
            <!-- 22345 -->
            <div class="">
              <button
                v-for="(level, index) in allLevelLists"
                type="button"
                class="btn my-1 p-2"
                :class="filterClass(index, level)"
                @click="updateSelectLevel(level)"
              >
                <span class="filter-font" :class="filterFontClass(level)">{{
                  level
                }}</span>
              </button>
              <button
                v-if="isBookandVideo"
                type="button"
                class="btn my-1 p-2"
                :class="filterClass(allLevelLists.length, '*')"
                @click="updateSelectLevel('*')"
              >
                <span class="filter-font" :class="filterFontClass('*')"
                  >Video</span
                >
              </button>
            </div>
            <!--  -->
            <div class="mt-4">
              {{ $t("check-which-materials-you-want-to-open") }}
            </div>
            <div class="table-responsive" v-if="textbookList">
              <h2 v-if="textbookList.length === 0">
                {{ $t("no-relevant-records") }}
              </h2>
              <table class="table table-striped" v-else>
                <thead>
                  <tr>
                    <th>
                      <div class="custom-control custom-checkbox form-check">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck2"
                          @click="selectAllTBft"
                          v-model="selectAllTB"
                        />
                        <label
                          class="custom-control-label"
                          for="customCheck2"
                        ></label>
                      </div>
                    </th>
                    <th
                      @click="sortTable('level')"
                      class="pointer"
                      v-if="courseInfo.cntLevel !== 0"
                    >
                      {{ $t("level")
                      }}<i class="zmdi zmdi-swap-vertical ml-1 zmdi-hc-lg"></i>
                    </th>
                    <th
                      @click="sortTable('unit')"
                      class="pointer"
                      v-if="courseInfo.cntUnit !== 0"
                    >
                      {{ $t("unit") }}
                      <i class="zmdi zmdi-swap-vertical ml-1 zmdi-hc-lg"></i>
                    </th>
                    <th @click="sortTable('resource_name')" class="pointer">
                      {{ $t("material") }}
                      <i class="zmdi zmdi-swap-vertical ml-1 zmdi-hc-lg"></i>
                      <!-- <i class="zmdi zmdi-swap-vertical ml-1"></i> -->
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="tb in copyTextbookList" :key="tb.resourceid">
                    <td>
                      <div class="custom-control custom-checkbox form-check">
                        <input
                          type="checkbox"
                          class="custom-control-input chkbox"
                          :id="tb.resourceid"
                          v-model="openedTextbookList"
                          :value="`${tb.colid}_${tb.resourceid}`"
                        />
                        <!-- {{ tb.resourceid }} -->
                        <label
                          class="custom-control-label"
                          :for="tb.resourceid"
                        ></label>
                      </div>
                    </td>
                    <td v-if="courseInfo.cntLevel !== 0">
                      <span v-if="tb.level !== ''"
                        >{{ $t("level") }} {{ tb.level }}</span
                      >
                      <span v-else></span>
                    </td>
                    <td v-if="courseInfo.cntUnit !== 0">
                      <span v-if="tb.unit !== ''"
                        >{{ $t("unit") }} {{ tb.unit }}</span
                      >
                      <span v-else></span>
                    </td>
                    <td>
                      <!-- <span v-if="tb.unit !== ''" style="font-size: 14px"
                        >{{ tb.unit }} -
                      </span> -->
                      {{ tb.resource_name }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-outline btn-rounded"
              data-dismiss="modal"
            >
              {{ $t("cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-primary btn-rounded"
              data-dismiss="modal"
              @click="multiOpenSetting()"
            >
              {{ $t("save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <!-- Assignment MODAL -->
    <div
      class="modal fade bd-example-modal-xl"
      id="AssignmentModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div
        class="
          modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable
        "
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t("assignment") }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true" class="zmdi zmdi-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <form v-if="studentList.length > 0">
              <div class="form-group row">
                <label class="col-form-label col-sm-3 text-right">{{
                  $t("assignment-name")
                }}</label>
                <div class="col-sm-6">
                  <input
                    type="text"
                    id="agtname"
                    class="form-control form-control-lg"
                    :placeholder="$t('assignment-name')"
                    v-model="newAgtName"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="control-label text-right col-sm-3">{{
                  $t("material")
                }}</label>
                <div class="col-sm-9">
                  <div class="bg-light rounded" data-scroll="dark">
                    <ul class="sequence a-sequence">
                      <draggable
                        class="list-group"
                        tag="ul"
                        v-model="tempAList"
                        v-bind="dragOptions"
                        @start="drag = true"
                        @end="drag = false"
                      >
                        <li
                          v-for="(ta, index) in tempAList"
                          :key="index"
                          class="
                            d-flex
                            justify-content-between
                            border
                            bg-white
                            rounded
                          "
                        >
                          <div class="d-flex justify-content-start">
                            <div class="btn btn-nostyle btn-move">
                              <i class="la la-ellipsis-v"></i
                              ><i class="la la-ellipsis-v"></i>
                            </div>
                            <span
                              v-if="ta.note === 'book'"
                              class="row col-sm-12"
                            >
                              <span
                                class="
                                  badge badge-pill badge-primary
                                  fix-badge-height
                                  mr-1
                                "
                                >{{ $t("reading") }}</span
                              >
                              <span class="d-flex align-items-center">{{
                                ta.resource_name
                              }}</span>
                            </span>
                            <div
                              v-else-if="ta.note === 'video'"
                              class="row col-sm-12"
                            >
                              <div>
                                <span
                                  class="
                                    badge badge-pill badge-warning
                                    fix-badge-height
                                    mr-1
                                  "
                                  >{{ $t("watching") }}</span
                                >
                              </div>
                              <span class="d-flex align-items-center">
                                {{
                                  ta.resource_name + " - " + ta.material_name
                                }}
                              </span>
                            </div>
                            <span v-else class="row col-sm-12">
                              <span
                                class="
                                  badge badge-pill badge-accent
                                  fix-badge-height
                                  mr-1
                                "
                                >{{ $t("speaking-quiz") }}</span
                              >
                              <span class="d-flex align-items-center"
                                >{{ ta.resource_name }} -
                                <span v-if="ta.material_name !== 'undefined'">{{
                                  ta.material_name
                                }}</span>
                                <span v-else>{{ $t("book") }}</span>
                              </span>
                            </span>
                          </div>

                          <i
                            @click="removeAssignment(ta.note, ta)"
                            class="
                              zmdi zmdi-minus-circle zmdi-hc-2x
                              text-secondary
                              pointer
                            "
                          ></i>
                          <!-- </button> -->
                        </li>
                      </draggable>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-form-label col-sm-3 text-right">{{
                  $t("due")
                }}</label>
                <div class="col-sm-8">
                  <date-picker
                    v-model="AssignmentDue"
                    valueType="format"
                    range
                    :disabled-date="disabledBeforeToday"
                  ></date-picker>
                </div>
                <!-- <div class="col-2 pt-2 pl-0">{{ AssignmentDue }}</div> -->
              </div>
              <div class="form-group row align-items-start">
                <label class="control-label text-right col-sm-3"></label>
                <small class="col-sm-7"
                  ><span class="text-danger">*</span>
                  {{
                    $t("press-and-hold-the-ctrl-key-for-multiple-selections")
                  }}.</small
                >
              </div>
              <div class="form-group row col-sm-12 mb-5">
                <label class="control-label text-right col-sm-3">{{
                  $t("for-students")
                }}</label>
                <div class="col-sm-9">
                  <div
                    v-if="showStuTable && filterStdList.length !== 0"
                    class="col-sm-12 row"
                  >
                    <!-- <label class="control-label text-right col-sm-3"></label> -->
                    <div class="col-sm-12">
                      <input
                        type="text"
                        id="searchStd"
                        class="form-control form-control-lg"
                        :placeholder="$t('search-student-name')"
                        v-model="searchstdName"
                      />
                    </div>
                    <div
                      class="custom-control custom-checkbox col-sm-12 ml-3 mt-3"
                    >
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="std"
                        v-model="selectAllS"
                        name="std"
                      />
                      <label class="custom-control-label" for="std">
                        <strong class="h6">{{ $t("all-students") }}</strong>
                      </label>
                    </div>
                    <div
                      v-for="(stu, index) in filterStdList"
                      :key="stu.id + index"
                      class="col-sm-4 agtbox"
                    >
                      <!-- @click="shiftSelect(event, stu.id, index)" -->
                      <span class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :id="stu.id"
                          :value="stu.id"
                          v-model="selectStudent"
                          @click="(shiftSid = stu.id), (shiftIndex = index)"
                        />
                        <label
                          class="custom-control-label "
                          :for="stu.id"
                          @click="(shiftSid = stu.id), (shiftIndex = index)"
                        >
                          <span class="h6">{{ stu.text }}</span>
                        </label>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <div v-else>
              <h3 class="text-danger">
                Please add students to the class first
              </h3>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-outline btn-rounded"
              data-dismiss="modal"
            >
              {{ $t("close") }}
            </button>
            <button
              type="button"
              class="btn btn-primary btn-rounded"
              data-dismiss="modal"
              data-toggle="modal"
              data-target="#AssignmentModal-2"
              :disabled="AssignmentSetting"
              v-if="studentList.length > 0"
            >
              {{ $t("next") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- AssignmentModal-2 MODAL-->
    <div
      class="modal fade"
      id="AssignmentModal-2"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalTitle1">{{ $t("assignment") }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true" class="zmdi zmdi-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <h5>{{ $t("how-difficult-is-this-assignment") }}?</h5>
            <p>
              {{
                $t(
                  "system-will-send-more-rewards-to-more-difficult-assignment"
                )
              }}.
            </p>
            <p
              v-for="(reward, index) in rewardList"
              :key="reward.exp"
              class="mb-0 monospace"
            >
              {{ $t("level") }}
              <span :class="`yellow-${index + 1}`">{{ index + 1 }} </span>

              => {{ $t("exp") }}.
              <span style="font-weight: bold">{{ reward.exp }}</span>

              , {{ $t("lucky-draw-ticket") }}
              <span style="font-weight: bold">{{ reward.ticket }}</span>
            </p>
            <div class="text-center mt-4 mb-4">
              <div class="form-check form-check-inline text-primary">
                {{ $t("easy") }}
              </div>
              <div
                class="custom-control custom-radio custom-control-inline mx-2"
                v-for="(d, i) in difficultList"
                :key="d"
              >
                <input
                  type="radio"
                  :id="d"
                  name="RadioInline"
                  class="custom-control-input pointer"
                  v-model="difficult"
                  :value="d"
                />
                <label
                  class="custom-control-label pointer"
                  :class="`yellow-${i + 1}`"
                  :for="d"
                  >{{ d }}</label
                >
              </div>

              <div class="form-check form-check-inline text-primary">
                {{ $t("difficult") }}
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-outline btn-rounded"
              data-dismiss="modal"
            >
              {{ $t("cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-primary btn-rounded"
              data-dismiss="modal"
              @click="setAssignment()"
            >
              {{ $t("assign") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- AssignmentModal-2 MODAL-->
    <div
      class="modal fade"
      id="messageModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalTitle1">{{ $t("message") }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true" class="zmdi zmdi-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <p>{{ $t("no-related-library-can-be-added") }}.</p>
            <p>
              {{
                $t(
                  "please-create-a-library-of-the-resource-before-adding-the-material"
                )
              }}
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-outline btn-rounded"
              data-dismiss="modal"
            >
              {{ $t("close") }}
            </button>
            <button
              type="button"
              class="btn btn-primary btn-outline btn-rounded"
              data-dismiss="modal"
              @click="gotoCreateCol()"
            >
              {{ $t("create-library") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- topic modal -->
    <TopicModal
      :topicList="topicList"
      :selectTopic="selectTopic"
      :selectType="selectType"
      @updateTopic="updateTopic"
      @getMList="getMList"
      @addselectLevelList="addselectLevelList"
    ></TopicModal>
    <!--  -->
  </div>
</template>

<script>
import {
  ApiSearchCourseResource,
  ApiGetVideoMaterial,
  ApiSetAssignment,
  ApiGetOpenResource,
  ApiPostMultiOpenSetting,
} from "../http/apis/CourseDetail";
import {
  ApiGetCollectionList,
  ApiGetResource,
  ApiAddResource,
  ApideleteResource,
} from "../http/apis/Collection";
// import CourseHeader from "../components/CourseHeader";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import dayjs from "dayjs";
import $ from "jquery";
import draggable from "vuedraggable";
// import _ from "lodash";
import sortBy from "lodash/sortBy";
import courseInfo from "../store/module/courseInfo";
import FilterButtonGroup from "../components/FilterButtonGroup";
import TopicModal from "../components/TopicModal";
export default {
  name: "CourseMaterial",
  components: {
    CourseHeader: () => import("@/components/CourseHeader.vue"),
    DatePicker,
    draggable,
    SearchGroup: () => import("@/components/SearchGroup.vue"),
    FilterButtonGroup,
    TopicModal,
    // Multiselect
  },
  data(vm) {
    return {
      courseid: this.$route.params.courseid,
      searchRname: "",
      typeList: [
        { text: vm.$t("all-type"), id: "all" },
        { text: vm.$t("picture-book"), id: "book" },
        { text: vm.$t("video"), id: "video" },
      ],
      selectType: "all",

      selectSortType: "title_asc",
      searchStatus: false,
      searchRList: [],
      courseid: this.$route.params.courseid,
      // tempAssignmentList: [],
      clicked: [],
      videoMaterialList: [],
      tempRname: "",
      tempVMList: [],
      collectionList: [],
      selectCol: "",
      tempResource: {},
      tempcolid: "",
      textbookList: [],
      studentList: [],
      selectStudent: [],
      tempSelectStudent: [],
      selectAllS: false,
      AssignmentDue: null,
      difficult: "1",
      difficultList: ["1", "2", "3", "4", "5"],
      tempAIDList: [],
      tempAList: [],
      openedTextbookList: [],
      lastCheckedIdx: -1,
      setStudent: false,
      existCollectionName: [],
      pkgid: {},
      showStuTable: true,
      courseInfo: {},
      selectAllTB: "",
      sortStatus: false,
      tempSortItem: "",
      copyTextbookList: [],
      courseOverview: [],
      newAgtName: "",
      mfilter: "",
      tempSearchName: "",
      rewardList: [
        { exp: "100", ticket: "1" },
        { exp: "150", ticket: "1" },
        { exp: "200", ticket: "2" },
        { exp: "250", ticket: "2" },
        { exp: "300", ticket: "3" },
      ],
      setResourceArray: [],
      softStatus: false,
      selectLevelList: [],
      tempLevelList: [],
      tempUnitList: [],
      codeNumber: -1,
      codeNumber2: -1,
      templl: [],
      templu: [],
      searchstdName: "",
      selectTopic: "",
      topicList: [],
      searchKeyword: "",
      saveLevel: [],
      openAllMaterial: false,
      allLevelLists: [],
      isBookandVideo: false,
      quickSelectLevel: "",
      allMaterial: [],
      copyQuickList: [],
      //shift多選
      haveShiftSelect: false,
      // html save
      shiftIndex: null,
      shiftSid: null,
      //
      saveShiftSindex: null,
      saveShiftTwoSindex: null,
      // startcheck:null,
      // agtcheckboxes : document.querySelectorAll('agtbox input[type=checkbox]')
    };
  },
  created() {
    this.$store.dispatch("common/setLoading", true);
    //列表資訊從menulift call (為了重複使用)
    // this.textbookList = this.textbookLists;
    this.openedTextbookList = this.openedTextbookLists;
    this.studentList = this.studentLists;
    this.tempAIDList = this.tempAIDLists;
    this.tempAList = this.tempALists;
    this.pkgid = this.pkgids;
    this.courseInfo = this.courseInfos;
    this.courseOverview = this.courseOverviews;
    this.getLevelList();
  },
  mounted() {
    if (this.openAgt) {
      $("#AssignmentModal").modal("show");
      this.$store.dispatch("courseInfo/setOpenAgt", false);
    }
    $(function() {
      $('[data-toggle="tooltip"]').tooltip();
    });
    setTimeout(() => {
      //
      console.log("box set");
      const checkbox = document.querySelectorAll(".agtbox");
      const checkboxArr = Array.from(checkbox);
      checkboxArr.map((item) =>
        item.addEventListener("click", this.shiftMultipleSelect)
      );
    }, 1000);
    //
  },
  watch: {
    // shiftIndex: {
    //   handler: function(nval, oval) {
    //     let vm = this;
    //     vm.saveShiftSindex = oval;
    //   },
    //   deep: true,
    // },
    courseOverviews() {
      this.courseOverview = this.courseOverviews;
    },
    courseInfos() {
      this.courseInfo = this.courseInfos;
    },
    pkgids() {
      this.pkgid = this.pkgids;
    },
    openedTextbookLists() {
      this.openedTextbookList = [...this.openedTextbookLists];
    },

    studentLists() {
      this.studentList = this.studentLists;
    },
    selectAllS() {
      if (this.selectAllS) {
        // this.tempSelectStudent = this.selectStudent;
        this.selectStudent = [];
        this.studentList.forEach((std) => {
          this.selectStudent.push(std.id);
          std;
        });
        // this.selectStudent.push("*");
      } else {
        console.log("觸發 selectALLS");
        this.selectStudent = this.tempSelectStudent;
      }
    },
    tempAIDLists() {
      this.tempAIDList = this.tempAIDLists;
    },
    tempALists() {
      this.tempAList = this.tempALists;
    },
    openAllMaterial() {
      console.log("call open all material");
      this.quickSelectAllMaterial();
    },
  },
  computed: {
    quickOpenList() {
      return this.copyTextbookList;
    },
    filterStdList() {
      if (this.searchstdName !== "") {
        let temp = this.studentList.filter((std) => {
          return std.text
            .toLowerCase()
            .includes(this.searchstdName.toLowerCase());
        });
        return temp;
      } else {
        return this.studentList;
      }
    },
    unitLists() {
      let vm = this;

      this.copyTextbookList.forEach((element, i) => {
        if (
          element.unit !== undefined &&
          element.unit !== "" &&
          !vm.templu.includes(element.unit)
        ) {
          vm.tempUnitList[i] = false;
          vm.templu.push(element.unit);
        }
      });
      this.templu.sort();
      return this.templu;
    },
    sortMyList(mtList) {
      let sortMaterial = [];
      let openb = this.textbookList.filter((item) => {
        return item.openflag === "true" && item.note === "book";
      });
      let openv = this.textbookList.filter((item) => {
        return item.openflag === "true" && item.note === "video";
      });
      let sortLevel = [];
      if (!this.selectLevelList.includes("*")) {
        sortLevel = this.selectLevelList;
      }
      if (this.mfilter === "openm") {
        sortMaterial = this.$_sortMaterial(
          this.openedMList,
          this.selectSortType,
          this.selectLevelList
        );
      } else if (this.mfilter === "openb") {
        sortMaterial = this.$_sortMaterial(openb, this.selectSortType, []);
      } else if (this.mfilter === "openv") {
        sortMaterial = this.$_sortMaterial(openv, this.selectSortType, []);
      } else {
        if (this.searchKeyword === "") {
          sortMaterial = this.$_sortMaterial(
            this.textbookList,
            this.selectSortType,
            sortLevel
          );
        } else {
          sortMaterial = [...this.textbookList];
        }
      }

      return sortMaterial;
    },

    openAgt() {
      return this.$store.state.courseInfo.openAgt;
    },

    sortTypeList() {
      return this.$store.state.common.sortTypeList;
    },
    courseOverviews() {
      return this.$store.state.courseInfo.courseOverview;
    },
    courseInfos() {
      return this.$store.state.courseInfo.courseInfo;
    },
    openedMList() {
      if (this.textbookList && this.textbookList.length !== 0) {
        return this.textbookList.filter((item) => {
          return item.openflag === "true";
        });
      }
    },
    openedBookList() {
      if (this.textbookList && this.textbookList.length !== 0) {
        return this.textbookList.filter((item) => {
          return item.openflag === "true" && item.note === "book";
        });
      }
    },
    openedVideoList() {
      if (this.textbookList && this.textbookList.length !== 0) {
        return this.textbookList.filter((item) => {
          return item.openflag === "true" && item.note === "video";
        });
      }
    },
    closedMList() {
      if (this.textbookList && this.textbookList.length !== 0) {
        return this.textbookList.filter((item) => {
          return item.openflag !== "true";
        });
      }
    },
    filterCollectionList() {
      this.existCollectionName = [];

      return this.collectionList.filter((item) => {
        if (item.rid === this.tempResource.resourceid) {
          this.existCollectionName.push(item.text);
        }
        return item.rid !== this.tempResource.resourceid;
      });
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
    AssignmentSetting() {
      if (
        this.AssignmentDue === null ||
        this.selectStudent.length <= 0 ||
        this.newAgtName === ""
      ) {
        return true;
      } else {
        if (this.AssignmentDue.includes(null)) {
          return true;
        } else {
          return false;
        }
      }
    },
    pkgids() {
      return this.$store.state.courseInfo.courseInfo.pkgid;
    },
    openedTextbookLists() {
      return this.$store.state.courseInfo.openedTextbookList;
    },

    studentLists() {
      return this.$store.state.courseInfo.forSelectStudentList;
    },
    userid() {
      return this.$store.state.auth.userid;
    },
    tempAIDLists() {
      return this.$store.state.courseInfo.caidList;
      // return this.$store.state.courseInfo.tempAIDList[this.courseid] === undefined ?  this.tempAIDList : this.$store.state.courseInfo.tempAIDList[this.courseid] ;
    },
    tempALists() {
      return this.$store.state.courseInfo.caList;
    },
  },
  methods: {
    resetEvent(e, sid, sindex) {
      console.log("remove event");
      const checkbox = document.querySelectorAll(".agtbox");
      const checkboxArr = Array.from(checkbox);
      checkboxArr.map((item) => {
        item.removeEventListener("click", this.shiftMultipleSelect),
          item.addEventListener("click", this.shiftMultipleSelect);
      });
    },
    shiftMultipleSelect(e, sid, sindex) {
      let vm = this;
      this.resetEvent();
      console.log("e.shiftKey", e.shiftKey); //判断shift是否按下
      if (e.shiftKey) {
        // 123
        if (this.haveShiftSelect === true) {
          this.saveShiftTwoSindex = this.shiftIndex;
          console.log("2選");
          console.log("1 = ", this.saveShiftSindex);
          console.log("2 = ", this.saveShiftTwoSindex);
          this.selectStudent = [];

          this.filterStdList.forEach((item, index) => {
            //  1 > 2
            if (
              vm.saveShiftSindex > vm.saveShiftTwoSindex &&
              index >= vm.saveShiftTwoSindex &&
              index <= vm.saveShiftSindex
            ) {
              console.log("this.shiftIndex > sindex");

              vm.selectStudent.push(item.id);
            } else if (
              vm.saveShiftSindex < vm.saveShiftTwoSindex &&
              index >= vm.saveShiftSindex &&
              index <= vm.saveShiftTwoSindex
            ) {
              console.log("this.shiftIndex < sindex");
              vm.selectStudent.push(item.id);
            } else if (
              vm.saveShiftSindex === vm.saveShiftTwoSindex &&
              index === vm.shiftIndex
            ) {
              vm.selectStudent = [];
              vm.selectStudent.push(item.id);
            }
          });
        } else {
          this.saveShiftSindex = this.shiftIndex;
          console.log("1選");
          console.log(this.selectStudent.includes(this.shiftSid));
          // if (!this.selectStudent.includes(sid)) {
          this.selectStudent.push(this.shiftSid);
          this.haveShiftSelect = true;
          // }
          console.log("this.shiftIndex = ", this.shiftIndex);
          this.shiftIndex = this.shiftIndex;
        }
        // 123
      } else if (this.haveShiftSelect === true) {
        this.shiftIndex = null;
        this.haveShiftSelect = false;
        this.selectStudent = [];
        if (!vm.selectStudent.includes(sid)) {
          vm.selectStudent.push(sid);
        }
      }
    },
    quickSelectAllMaterial() {
      console.log(this.openAllMaterial);
      let vm = this;
      if (!this.openAllMaterial) {
        console.log("清空");
        vm.openedTextbookList = [];
        // 如果原本就是開啟的 要設成開啟嗎?
        // vm.allMaterial.forEach(function(item, i) {
        //   if (item.openflag === "true") {
        //     vm.openedTextbookList.push(`${item.colid}_${item.resourceid}`);
        //   }
        // });
        //
        // vm.openedTextbookList = [];
      } else {
        this.copyQuickList = [...this.copyTextbookList];
        //實現全選
        // this.openedTextbookList = [...this.allMaterial]
        this.allMaterial.forEach(function(item, i) {
          console.log("push item");
          vm.openedTextbookList.push(`${item.colid}_${item.resourceid}`);
        });
        console.log(vm.openedTextbookList);
      }
    },
    //
    //
    async updateQuickMaterial() {
      let vm = this;
      let searchObj = {
        type: "*",
        keyword: "",
      };
      let result = await ApiSearchCourseResource.post(this.courseid, searchObj)
        .then((response) => {
          console.log(response);
          let temp = [];
          this.allMaterial = response.record;
          temp = response.record.filter((item) => {
            if (this.quickSelectLevel === "*") {
              return item.note === "video";
            } else {
              return item.level === this.quickSelectLevel;
            }
          });
          this.copyTextbookList = temp.sort();
          if (response.status === "success") {
            return true;
          }
        })
        .catch((err) => {});
      if (result) {
        console.log(
          "search 的結果在這裡!!! copyTextbookList= ",
          this.copyTextbookList
        );
      }
    },
    //
    updateSelectLevel(level) {
      console.log(level);
      if (this.quickSelectLevel !== level) {
        this.quickSelectLevel = level;
      }
      this.updateQuickMaterial();
    },
    filterClass(index, level) {
      let temp = "";
      if (index === 0) {
        temp = "rectangle";
      } else if (index === this.allLevelLists.length) {
        temp += " rectangleend";
      } else {
        temp = " square";
      }
      if (index % 2 === 0) {
        temp += " filter-even-color";
      } else {
        temp += " filter-odd-color";
      }
      if (this.quickSelectLevel === level) {
        temp += " select-filter-color";
      }
      if (index === this.allLevelLists.length - 1 && !this.isBookandVideo) {
        temp += " rectangle2 ";
      } else if (index === this.allLevelLists.length) {
        temp += " rectangle2 ";
      }
      return temp;
    },
    filterFontClass(level) {
      let temp = "";
      if (this.quickSelectLevel === level) {
        temp += " select-filter-font";
      } else {
        temp += " filter-font";
      }
      return temp;
    },
    async getLevelList() {
      let vm = this;
      let searchObj = {
        type: "*",
        keyword: "",
      };
      let result = await ApiSearchCourseResource.post(this.courseid, searchObj)
        .then((response) => {
          console.log(response);
          let temp = [];
          response.record.forEach((element) => {
            if (
              (element.note === "video" || element.note === "book") &&
              !temp.includes(element.note)
            ) {
              temp.push(element.note);
            }
            if (
              element.level !== undefined &&
              element.level !== "" &&
              !vm.allLevelLists.includes(element.level)
            ) {
              vm.allLevelLists.push(element.level);
            }
          });
          // console.log("alllevellist = ", this.allLevelLists);
          this.allLevelLists.reverse();
          this.allLevelLists.sort((a, b) => {
            // console.log(a, b);
            if (b === "aa") {
              return 1;
            } else if (a === "aa") {
              return -1;
            }
            return a.toLowerCase() > b.toLowerCase()
              ? 1
              : a.toLowerCase() < b.toLowerCase()
              ? -1
              : 0;
          });
          if (temp.length === 2) {
            this.isBookandVideo = true;
          }

          if (response.status === "success") {
            return true;
          }
        })
        .catch((err) => {});
      if (result) {
      }
    },
    updateKeyword(keyword) {
      this.searchKeyword = keyword;
    },
    addselectLevelList(level) {
      if (level !== "*") {
        this.selectTopic = "";
      }

      if (this.selectTopic === "") {
        $("input[type=radio][name=topicRadio]").prop("checked", false);
      }

      if (!this.selectLevelList.includes(level)) {
        this.selectLevelList.push(level);
        if (this.selectLevelList.length >= 2) {
          this.selectLevelList.shift();
        }
      }
      if (level === "*") {
        if (!this.selectLevelList.includes("*")) {
          this.selectLevelList = [];
        }
        this.selectType = "video";
      } else {
        this.selectType = "book";
      }
    },
    updateTopic(topic) {
      // console.log("updateTopic = ", topic);
      this.selectTopic = topic;
      if (topic !== "") {
        this.mfilter = "";
        this.saveLevel = [...this.selectLevelList];
        this.selectLevelList = ["*"];
      } else {
        this.selectLevelList = [...this.saveLevel];
      }
    },
    updateSelectType(type) {
      this.selectType = type;
    },

    openTopicModal() {
      $("#topicModal").modal("show");
    },
    downloadFile(link) {
      setTimeout(() => window.open(link), 500);
    },
    // select by shift end
    filterLevel(level) {
      if (this.codeNumber !== level) {
        this.copyTextbookList = this.copyTextbookList.filter((item) => {
          return item.level.indexOf(level) !== -1;
        });
      } else {
        this.codeNumber = -1;
        this.copyTextbookList = [...this.textbookList];
      }
    },
    filterUnit(unit) {
      if (this.codeNumber2 !== unit) {
        this.copyTextbookList = this.copyTextbookList.filter((item) => {
          return item.unit.indexOf(unit) !== -1;
        });
      } else {
        this.codeNumber2 = -1;
        this.copyTextbookList = [...this.textbookList];
      }
    },
    getTopicList(topic) {
      // console.log("all topic = ", topic);
      this.topicList = topic;
    },
    // 這裡才是final 重要 超重要
    getMList(textbookList) {
      this.textbookList = textbookList;
      this.textbookList = this.sortMyList;
      this.softStatus = true;
      this.$store.dispatch("common/setLoading", false);
    },
    getFilterInfo(selectLevelList, selectSortType) {
      let sortType = selectSortType.split("_")[0];
      if (sortType === "title") {
        this.tempSortItem = "resource_name";
      }
      this.selectLevelList = selectLevelList;
      this.selectSortType = selectSortType;
    },
    changeMfilter(filterName) {
      if (filterName === this.mfilter) {
        this.mfilter = "";
        this.selectLevelList = [...this.saveLevel];
        this.searchMyList();
      } else {
        this.saveLevel = [...this.selectLevelList];
        this.mfilter = filterName;
        this.searchMyList();
      }
    },
    sortTable(sortItem) {
      if (this.tempSortItem === sortItem) {
        this.copyTextbookList = this.copyTextbookList.reverse();
      } else {
        this.tempSortItem = sortItem;
        this.copyTextbookList = sortBy(
          this.copyTextbookList,
          [(obj) => obj[sortItem]],
          ["asc"]
        );
      }
    },
    disabledBeforeToday(date) {
      let today = new Date();
      today.setHours(0, 0, 0, 0);

      return date < today;
    },
    openAssignmentModal() {
      if (this.studentList.length <= 0) {
        this.$bus.$emit(
          "messsage:push",
          "Please add students to the course first.",
          "danger"
        );
      } else {
        $("#AssignmentModal").modal("show");
      }
    },
    // multiple select
    addTag(newTag) {
      const tag = {
        text: newTag,
        id: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
    },
    async getCollectionList(rid, obj) {
      let vm = this;
      this.tempResource = obj;
      this.collectionList = [];
      let result = await ApiGetCollectionList.get(this.userid, rid)
        .then((response) => {
          this.collectionList = response.record.map((o) => {
            return {
              id: o.collectionid,
              text: o.collection_name,
              rid: o.resourceid,
            };
          });
          if (response.status === "success") {
            return true;
          }
        })
        .catch((err) => {});
      if (result) {
        if (
          vm.existCollectionName.length !== 0 ||
          vm.filterCollectionList.length !== 0
        ) {
          $("#addtoColletion").modal("show");
        } else {
          $("#messageModal").modal("show");
        }
      }
    },

    addResource() {
      this.selectCol = this.selectCol.toString();
      this.tempResource.resourceid = this.tempResource.resourceid.toString();
      ApiAddResource.get(this.selectCol, this.tempResource.resourceid)
        .then((response) => {
          console.log(response);
          if (response.status === "success") {
            this.$bus.$emit(
              "messsage:push",
              "Successful addition to the collection.",
              "success"
            );
            this.selectCol = "";
          } else {
            this.$bus.$emit("messsage:push", "Unknown error.", "danger");
            this.selectCol = "";
          }
        })
        .catch((err) => {});
    },

    addToAssignmentList(m) {
      // this.clicked.push(m.resourceid);

      this.$store.dispatch("courseInfo/setAssignment", {
        assignment: m,
        id: m.resourceid,
      });
    },
    searchMyList() {
      if (this.searchKeyword !== "") {
        this.searchStatus = true;
        this.tempSearchName = this.searchKeyword;
      } else {
        this.searchStatus = false;
      }
      let sType = this.selectType;
      if (this.selectType === "all") {
        sType = "*";
      }
      if (this.mfilter === "openb") {
        sType = "book";
      } else if (this.mfilter === "openv") {
        sType = "video";
      }
      let sTopic = this.selectTopic;
      let searchObj = {
        type: sType,
        keyword: this.searchRname,
        topic: sTopic,
      };
      console.log("@@@@@searchMyList = @@@@", searchObj);
      ApiSearchCourseResource.post(this.courseid, searchObj)
        .then((response) => {
          response.record.forEach((element) => {
            if (element.unit === undefined) {
              element.unit = "";
            }
            element.link = element.information.includes("http");
          });
          this.textbookList = response.record;
        })
        .catch((err) => {});
    },
    async getVideoMaterial(Ncolid, rid) {
      let colid = Ncolid.split(";")[0];
      let result = await ApiGetVideoMaterial.get(colid, this.courseid, rid)
        .then((response) => {
          this.videoMaterialList = response.record;
          if (response.status === "success") {
            return true;
          }
        })
        .catch((err) => {});
      if (result) {
        this.videoMaterialList.forEach((el) => {
          el.resource_name = this.tempRname;
        });
      }
    },
    addtoSequence() {
      //e現在的格式 => MID_RID
      //新增一個ASS +  本來就在系統暫存的

      let result = this.tempVMList
        .filter((e) => {
          return this.tempAIDList.indexOf(e) === -1;
        })
        .concat(
          this.tempAIDList.filter((f) => {
            return this.tempVMList.indexOf(f) === -1;
          })
        );

      //取絕對差集 補集
      // result = id array
      //SET的時候傳整個OBJECT 所以要從ID列表得到整個OBJET
      //從ID => GET OBJECT

      //只需要MIDLIST 格式轉換 MID_RID => MID
      let copyVMList = [];
      result.forEach((item) => {
        item = item.split("_")[0];
        copyVMList.push(item);
      });

      let vmList = [];
      this.videoMaterialList.forEach((element) => {
        if (copyVMList.includes(element.materialid)) {
          vmList.push(element);
        }
      });

      // result要排序
      vmList.sort((a, b) => {
        return ("" + a.material_name).localeCompare(b.material_name);
      });

      //如果變動的本就存在 從暫存移除 不存在則加入暫存
      vmList.forEach((obj) => {
        if (this.tempAIDList.includes(obj.materialid + "_" + obj.resourceid)) {
          this.$store.dispatch("courseInfo/removeAssignment", {
            id: obj.materialid + "_" + obj.resourceid,
          });
        } else {
          this.$store.dispatch("courseInfo/setAssignment", {
            assignment: obj,
            id: obj.materialid + "_" + obj.resourceid,
          });
        }
      });
      this.$bus.$emit(
        "messsage:push",
        "Add to the temporary assignment list",
        "success"
      );
    },
    removeAssignment(type, obj) {
      if (type === "book") {
        this.$store.dispatch("courseInfo/removeAssignment", {
          id: obj.resourceid,
        });
      } else if (type === "video") {
        this.$store.dispatch("courseInfo/removeAssignment", {
          id: obj.materialid + "_" + obj.resourceid,
        });
      } else {
        this.$store.dispatch("courseInfo/removeAssignment", {
          id: obj.quizid,
        });
      }
    },
    gotoWebsite(obj) {
      console.log(obj);
      if (obj.note === "book") {
        console.log(
          `${process.env.VUE_APP_DOMAIN}/bktchr/?pkgid=${this.courseInfo.pkgid}&colid=${this.courseInfo.colid}&resid=${obj.resourceid}&mid=&lmsd=${process.env.VUE_APP_LMSD}&auth=${this.$store.state.auth.token}&crsid=${this.courseInfo.courseid}&userid=${this.userid}&LANG=${this.$i18n.locale}`
        );

        window.open(
          `${process.env.VUE_APP_DOMAIN}/bktchr/?pkgid=${this.courseInfo.pkgid}&colid=${this.courseInfo.colid}&resid=${obj.resourceid}&mid=&lmsd=${process.env.VUE_APP_LMSD}&auth=${this.$store.state.auth.token}&crsid=${this.courseInfo.courseid}&userid=${this.userid}&LANG=${this.$i18n.locale}`
        );
      } else {
        console.log(
          `${process.env.VUE_APP_DOMAIN}/vptchr/?pkgid=${this.courseInfo.pkgid}&colid=${this.courseInfo.colid}&resid=${obj.resourceid}&mid=&lmsd=${process.env.VUE_APP_LMSD}&auth=${this.$store.state.auth.token}&crsid=${this.courseInfo.courseid}&userid=${this.userid}&LANG=${this.$i18n.locale}`
        );
        window.open(
          `${process.env.VUE_APP_DOMAIN}/vptchr/?pkgid=${this.courseInfo.pkgid}&colid=${this.courseInfo.colid}&resid=${obj.resourceid}&mid=&lmsd=${process.env.VUE_APP_LMSD}&auth=${this.$store.state.auth.token}&crsid=${this.courseInfo.courseid}&userid=${this.userid}&LANG=${this.$i18n.locale}`
        );
      }
    },
    async setAssignment() {
      let obj = {};
      obj.userid = this.userid;
      obj.publish_date = dayjs(this.AssignmentDue[0]).unix();
      obj.expiry_date = dayjs(this.AssignmentDue[1]).unix();
      obj.difficult = this.difficult;
      obj.description = this.newAgtName;
      if (
        this.selectStudent.includes("*") ||
        this.selectStudent.length === this.studentList
      ) {
        obj.student = "all";
      } else {
        obj.student = this.selectStudent.join(";");
      }
      this.tempAList.forEach((el) => {
        if (el.note === "video") {
          this.$set(el, "assignment_type", "watching");
        } else if (el.note === "book") {
          this.$set(el, "assignment_type", "reading");
        } else {
          this.$set(el, "assignment_type", "speaking");
        }
      });
      obj.content = this.tempAList;
      let result = await ApiSetAssignment.post(this.courseid, obj)
        .then((response) => {
          if (response.status === "success") {
            this.$bus.$emit(
              "messsage:push",
              "New assignment success!",
              "success"
            );
            return true;
          } else {
            this.$bus.$emit("messsage:push", "Unknown error!!", "danger");
          }
        })
        .catch((err) => {});
      //新增作業成功
      if (result) {
        //移除INDEX
        this.$store.dispatch(
          "courseInfo/clearCourseTempAssignment",
          this.$route.params.courseid
        );
        //新增更新回去
        this.$store.dispatch(
          "courseInfo/updateTextbookList",
          this.$route.params.courseid
        );
        this.newAgtName = "";
        this.selectAllS = false;
        this.selectStudent = "";
        this.AssignmentDue = null;
        this.difficult = "1";
        this.$bus.$emit("messsage:push", "New assignment success.", "success");
      }
    },
    async multiOpenSetting() {
      console.log("multi select");
      let vm = this;
      this.selectAllTB = "";
      let openRes = [];
      let closeRes = [];
      this.$store.dispatch("common/setLoading", true);

      console.log("這次選中的列表");
      console.log(this.openedTextbookList);
      console.log("==========");
      console.log("vm.openedTextbookLists = ", this.openedTextbookLists);
      console.log(this.openedTextbookLists);
      // openedTextbookLists 之前設定以開放的
      // openedTextbookList  此次選中的

      // 已開放裡面沒包含選中的  將他PUSH到要設定成開放的列表
      // for (let i = 0; i < this.openedTextbookList.length; i++) {
      //   if (await !vm.openedTextbookLists.includes(vm.openedTextbookList[i])) {
      //     openRes.push(vm.openedTextbookList[i].split("_")[1]);
      //   }
      // }

      for (let i = 0; i < this.openedTextbookList.length; i++) {
        openRes.push(vm.openedTextbookList[i].split("_")[1]);
      }

      for (let i = 0; i < this.openedTextbookLists.length; i++) {
        // 選中裡面 沒有包含已開放的
        // 放到CLOSE裡面
        if (await !vm.openedTextbookList.includes(vm.openedTextbookLists[i])) {
          closeRes.push(vm.openedTextbookLists[i].split("_")[1]);
        }
      }

      openRes = openRes.join("|");
      console.log("openRes = ", openRes);
      let result = await ApiPostMultiOpenSetting.post(
        this.courseInfo.colid,
        this.$route.params.courseid,
        openRes,
        "true"
      )
        .then((response) => {
          console.log(response);

          return response;
        })
        .catch((err) => {});
      closeRes = closeRes.join("|");
      console.log("closeRes = ", closeRes);
      let result2 = await ApiPostMultiOpenSetting.post(
        this.courseInfo.colid,
        this.$route.params.courseid,
        closeRes,
        "false"
      )
        .then((response) => {
          console.log(response);
          return response;
        })
        .catch((err) => {});
      console.log("群體開放設定 return1 & 2", result, result2);
      if (result && result2) {
        this.$store.dispatch(
          "courseInfo/updateTextbookList",
          this.$route.params.courseid
        );
        this.$store.dispatch("common/setLoading", false);
      }
      if (result.status === "failed") {
        this.$bus.$emit("messsage:push", result.record, "danger");
      }
      if (result2.status === "failed") {
        this.$bus.$emit("messsage:push", result2.record, "danger");
      }
    },
    async getOpenResource(colid, rid, status, single = false) {
      console.log("控制資源開放與否");
      console.log(
        `/course/openresource/${colid}/${this.$route.params.courseid}/${rid}/${status}`
      );
      this.setResourceArray = [];
      this.setResourceArray.push(
        `/course/openresource/${colid}/${this.$route.params.courseid}/${rid}/${status}`
      );
      console.log(this.setResourceArray);
      if (single) {
        let result = await ApiGetOpenResource.getAll(this.setResourceArray)
          .then((response) => {
            console.log("set resource open = ", response);
            return response[0];
          })
          .catch((err) => {});
        console.log("result = ", result);
        if (result.status !== "failed") {
          this.$store.dispatch(
            "courseInfo/updateTextbookList",
            this.$route.params.courseid
          );
          this.$store.dispatch("common/setLoading", false);
        } else {
          this.$bus.$emit("messsage:push", result.record, "danger");
        }
      }
    },
    gotoSpeakingQuiz(m, rname = "") {
      $("#addSpeakingquiz").modal("hide");
      let mType = "video";
      if (m.note === "book") {
        mType = "book";
      }
      let url = `/quiz/${this.$route.params.course}/Speaking Quiz/${rname}/${m.material_name}/${this.courseid}/${mType}/${m.resourceid}/${m.materialid}`;
      url = url.replaceAll("?", "%3F");
      this.$router.push({
        path: url,
      });
    },
    gotoCreateCol() {
      this.$router.push({
        path: `/collection/create/${this.pkgid}`,
      });
    },
    copyMArray() {
      console.log("this.copyTextbookList = ", ...this.textbookList);
      // console.log("this.openedTextbookLists = ", this.openedTextbookLists);
      console.log("this.checkList = ", ...this.openedTextbookLists);
      this.updateQuickMaterial();
      // 勾選的還原
      this.openedTextbookList = [...this.openedTextbookLists];
      // filter list
      this.quickSelectLevel = this.selectLevelList[0];
      // 複製目前的清單到dialog
      this.copyTextbookList = [...this.textbookList];
    },
    selectAllTBft(event) {
      const vm = this;
      if (!event.currentTarget.checked) {
        console.log("清空");
        console.log("vm.copyTextbookList = ", vm.copyTextbookList);
        vm.copyTextbookList.forEach(function(item, i) {
          //
          if (
            vm.openedTextbookList.includes(`${item.colid}_${item.resourceid}`)
          ) {
            let index = vm.openedTextbookList.indexOf(
              `${item.colid}_${item.resourceid}`
            );
            vm.openedTextbookList.splice(index, 1);
          }
        });
        // vm.openedTextbookList = [];
      } else {
        //實現全選
        vm.copyTextbookList.forEach(function(item, i) {
          if (
            !vm.openedTextbookList.includes(`${item.colid}_${item.resourceid}`)
          ) {
            vm.openedTextbookList.push(`${item.colid}_${item.resourceid}`);
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
// quick modal
.rectangle {
  width: 42px;
  height: 42px;
  border-radius: 16px 0px 0px 16px;
}
.rectangle2 {
  width: 42px;
  height: 42px;

  border-radius: 0px 16px 16px 0px;
}
.rectangleend {
  width: 90px;
  height: 42px;

  border-radius: 0px 16px 16px 0px;
}
.square {
  width: 42px;
  height: 42px;
  left: 403px;
  top: 329px;
}

.select-filter-color {
  background: #32c1db !important;
}
.filter-odd-color {
  background: #c0d0e0;
}
.filter-even-color {
  background: #d8e3ef;
}
.filter-font {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  /* or 119% */

  letter-spacing: 0.32px;

  color: #617182;
}
.select-filter-font {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  /* or 119% */
  letter-spacing: 0.32px;
  color: #ffffff;
}
// // quick modal end

.sequence {
  overflow-y: scroll !important;
}

.a-sequence {
  overflow-y: scroll !important;
}
.bold {
  font-weight: bold;
}

.cus-img {
  max-height: 100%;
  max-width: 100%;
  width: auto;
  height: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
.overlay-icon {
  z-index: 99;
}
.hover-expand:hover {
  .hover-blue {
    color: #32c1db;
  }
}

.custom-control-label.text-xs {
  font-size: 16px !important;
}
.text-xs.fw300 {
  font-size: 14px !important;
}
.mfilter-board {
  .card-title {
    color: #ffffff;
  }
  .mfilter-icon {
    color: #ffffff;
  }
}

.mfilter-board:hover {
  cursor: pointer;
  .mfilter-icon {
    color: #ffce67;
  }
}

.tooltip {
  width: 602px !important;
  min-width: 602px !important;
}

.monospace {
  font-family: "Roboto", monospace;
}
.yellow-1 {
  color: #fad961;
}
.yellow-2 {
  color: #f9bc4f;
}
.yellow-3 {
  color: #f8a03d;
}
.yellow-4 {
  color: #f78c30;
}
.yellow-5 {
  color: #f76b1c;
}
.download-text {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 21px;
  /* identical to box height, or 162% */

  letter-spacing: 0.32px;

  color: #617182;
}
@media (min-width: 768px) {
  .modal-xl {
    width: 90%;
    max-width: 1200px;
  }
}

.download-border {
  border: solid #f0f6ff;
  border-width: 2px;
}

.download-newblock {
  box-sizing: border-box;
  width: 180px;
  height: 100px;
  left: 552px;
  top: 1121px;
  border: 2px solid #f0f6ff;
  border-radius: 16px;
}
.download-icon:hover {
  color: #32c1db;
}
.download-block:hover > div > span > .download-icon {
  color: #32c1db;
}
.mydownload:hover {
  .download-newblock {
    border: 2px solid #32c1db;
  }
  .download-icon {
    color: #32c1db;
  }
}

.download-item {
  height: 100px;
}
.pointer-arrow {
  cursor: default !important;
}
</style>
